import { createAction } from "@reduxjs/toolkit";
import { TAsset } from "types";

export const streamUpdateAsset = createAction("assets/streamUpdate", (data: TAsset) => ({
  payload: data,
}));
